import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { DashboardInnerTopMenuComponent } from '@rollit/shared/common';
import { SuperannuationComponent } from './components/superannuation.component';


const superannuationRoutes: Routes = [
  {
    path: 'superannuation',
    component: SuperannuationComponent,
    data: {
      title: 'Superannuation',
      topMenuItem: {
        component: DashboardInnerTopMenuComponent,
        data: { type: 'single', subNav: false },
      },
    },
    children: [
    ],
  },
  {
    path: 'superannuation/:id',
    component: SuperannuationComponent,
    data: {
      title: 'Superannuation',
      topMenuItem: {
        component: DashboardInnerTopMenuComponent,
        data: { type: 'single', subNav: false },
      },
    },
    children: [
    ],
  },
];

@NgModule({
  imports: [RouterModule.forChild(superannuationRoutes)],
  exports: [RouterModule],
})
export class SuperannuationRoutingModule { }
